/**
 * Verlauf für Grafiken: Umfrage, Zustimmung, Wählergruppen und wichtige Ereignisse pro Monat.
 * Nur Anzeige. Liest den Zustand, zieht keinen Zufall und ändert keine Spielregeln.
 */
import { CRISES } from '../content/crises';
import { GROUPS } from '../content/axes';
import { S } from './state';
import { approval, poll } from './govern';

export type TraceEv = { k: 'law' | 'crisis' | 'scandal' | 'ltw' | 'budget' | 'fail'; t: string; good?: boolean };
export type TracePt = { m: number; leg: number; poll: number; appr: number; g: Record<string, number>; ev?: TraceEv[] };

const MAX = 400;
const r1 = (x: number) => Math.round(x * 10) / 10;

/** Stand am Monatsende festhalten, samt der Ereignisse dieses Monats. */
export function traceTick(start = false) {
  if (!S || S.phase !== 'govern' && !start) return;
  const tr: TracePt[] = (S as any).trace || ((S as any).trace = []);
  const ev: TraceEv[] = [];
  if (!start) {
    for (const L of S.laws as any[]) {
      if (L.stage === 'kraft' && !L.phase && !L.rep) ev.push({ k: 'law', t: L.t, good: true });
      if (L.stage === 'failed' && L.vote && L.failM == null) { L.failM = S.m; ev.push({ k: 'fail', t: L.t, good: false }); }
    }
    if (S.crisis && S.crisis.m === S.m) ev.push({ k: 'crisis', t: CRISES.find((c: any) => c.id === S.crisis!.id)?.t ?? 'Krise', good: false });
    if (S.scandal && S.scandal.m === S.m) ev.push({ k: 'scandal', t: 'Affäre im Kabinett', good: false });
    for (const e of S.log) { if (e.m !== S.m) break; if (/^Landtagswahl in /.test(e.t)) ev.push({ k: 'ltw', t: e.t.split(':')[0], good: e.k === 'good' ? true : e.k === 'bad' ? false : undefined }); if (/Haushalt .* scheitert/.test(e.t)) ev.push({ k: 'budget', t: 'Haushalt gescheitert', good: false }); }
  }
  const g: Record<string, number> = {}; for (const k in GROUPS) g[k] = r1(S.mood?.[k] ?? 0);
  const pt: TracePt = { m: S.m, leg: S.leg, poll: r1(poll()), appr: r1(approval()), g };
  if (ev.length) pt.ev = ev;
  if (tr.length && tr[tr.length - 1].m === S.m) tr[tr.length - 1] = { ...pt, ev: [...(tr[tr.length - 1].ev || []), ...ev] };
  else tr.push(pt);
  if (tr.length > MAX) tr.splice(0, tr.length - MAX);
}
